/**
 * @desc 通过管理域获取部门信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.BaseInfoDepartmentRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QueryBaseInfoPageResponse>>> {
  return defHttp.post({
    url: '/web/base/department',
    data,
  });
}

export function mock(
  data: defs.BaseInfoDepartmentRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.QueryBaseInfoPageResponse>>> {
  return defHttp.post({
    url: '/mock/web/base/department',
    data,
  });
}
